export const getConversationCloseButtonMode = (status, initialChannel, isEndUserConnected) => isEndUserConnected &&
    (status === 'awaitingpending' ||
        (status === 'open' && initialChannel !== 'email'))
    ? 'end'
    : 'close';
